export class RequestSupport {
  name: string;
  phone: string;
  email: string;
  userType: number;
  licenseNumber: string;
  subject: number;
  message: string;
}
